var map = {
	"./all-dark.svg": "676c",
	"./all-light.svg": "f224",
	"./all.svg": "21c3",
	"./calendar.svg": "9195",
	"./cancle.svg": "7469",
	"./close-outline.svg": "16b7a",
	"./doctor.svg": "935b",
	"./down.png": "6b73",
	"./down.svg": "3986",
	"./in progress.svg": "c120",
	"./pencil-line.svg": "a21b",
	"./search.png": "5b5d",
	"./search.svg": "7476",
	"./sending.svg": "2e54",
	"./success.svg": "c9f7",
	"./sucess.svg": "9ba3",
	"./transport.svg": "aa70"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "a941";